module.exports = require("/Users/kylemathews/programs/typography.js/packages/react-typography");



/*****************
 ** WEBPACK FOOTER
 ** /Users/kylemathews/programs/typography.js/packages/typography-design-tools/~/react-typography/index.js
 ** module id = 450
 ** module chunks = 0
 **/